import { render } from "./CongressionalGoldMedal.vue?vue&type=template&id=48f72f11"
import script from "./CongressionalGoldMedal.vue?vue&type=script&lang=ts"
export * from "./CongressionalGoldMedal.vue?vue&type=script&lang=ts"
script.render = render

export default script